<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
  },

  computed: {
    pathSource() {
      // Decodifica nome e tipo do ícone da prop
      let iconName = this.icon;
      let iconType = this.type;

      // Ajusta iconName e iconType se a prop icon incluir sufixo de tipo
      const suffixMatch = this.icon.match(/(.+)-(outline|solid)$/);
      if (suffixMatch) {
        iconName = suffixMatch[1];
        iconType = suffixMatch[2];
      }

      const key = `${iconName}-${iconType}`;
      let path = this.icons[key];
      // Fallback genérico para ícone phone
      if (!path && iconName === 'phone') {
        path = this.icons[`call-${iconType}`];
      }
      // Fallback genérico para ícone inbox
      if (!path && iconName === 'inbox') {
        path = this.icons[`mail-inbox-${iconType}`];
      }

      if (!path) {
        throw new Error(`Icon not found ${key}`);
      }

      return Array.isArray(path) ? path : [path];
    },
  },
};
</script>

<template>
  <svg
    v-if="iconLib === 'fluent'"
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="source in pathSource"
      :key="source"
      :d="source"
      fill="currentColor"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-for="(pathData, index) in pathSource" :key="index">
      <path
        :key="pathData"
        :d="pathData"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
